import React, { useState, useEffect, useContext } from 'react';
import { useQuery } from '@apollo/client';
import {
  useRouteMatch,
  useLocation,
  Route,
  Switch,
} from "react-router-dom";
import Queries from 'utils/Queries';
import Rubrique from 'components/Rubrique/Rubrique';
import Article from 'components/Article/Article';
import { SettingsContext } from 'Providers/SettingsProvider';

function SubRoutes ({
  root=false,
  id,
  localRoutes=[],
  depth=0
}) {
  const [ routesOk, setRoutesOk ] = useState([]);
  let { path } = useRouteMatch();
  const query= root ? Queries.subroutesroot : Queries.subroutes;
  const { updateLoadState,fetchedList,setIntroDone } = useContext(SettingsContext);
  const { networkStatus,data,refetch } = useQuery(query,{
    variables: { id:parseInt(id) },
  });
  const uuid=`subroute${id ? id : ''}`;
  useEffect(()=>updateLoadState(uuid,networkStatus),[networkStatus,updateLoadState,uuid]);
  useEffect(()=>{
    if(fetchedList.indexOf(uuid)===-1){
      console.log('fetch',uuid);
      refetch();
    }
  },[refetch,fetchedList,uuid]);
  const { pathname, search, state } = useLocation();
  useEffect(()=>{
    if (pathname!=='/') setTimeout(()=>setIntroDone(true),1000);
  },[pathname, setIntroDone]);
  useEffect(()=>{
      const rubriques = data ? data.rubriques : [];
      const articles = data ? data.articles : [];
      let res=[];
      let currentPath= path==='/' ? '' : path;
      rubriques.forEach((rub, i) => {
          res.push(<Route key={`${currentPath}/${rub.id}`} exact path={`${currentPath}/${rub.id}`}>
              <Rubrique id={rub.id} pathname={pathname} exact/>
          </Route>);
          res.push(<Route key={`${currentPath}/${rub.id}`} path={`${currentPath}/${rub.id}`}>
              <Rubrique id={rub.id} pathname={pathname}/>
          </Route>);
          if (rub.slugs && rub.slugs.length>0) {
              rub.slugs.forEach((slug, i) => {
                //console.log(`${currentPath}/${slug.slug}`);
                res.push(<Route key={`${currentPath}/${slug.slug}`} exact path={`${currentPath}/${slug.slug}`}>
                    <Rubrique id={rub.id} exact pathname={pathname}/>
                </Route>);
                res.push(<Route key={`${currentPath}/${slug.slug}`} path={`${currentPath}/${slug.slug}`}>
                    <Rubrique id={rub.id} pathname={pathname}/>
                </Route>);
            });
          }
      });
      articles.forEach((art, i) => {
          res.push(<Route key={`${currentPath}/article-${art.id}`} path={`${currentPath}/article-${art.id}`}>
              <Article id={art.id}/>
          </Route>);
          if (art.slugs && art.slugs.length>0) {
              art.slugs.forEach((slug, i) => {
                  res.push(<Route key={`${currentPath}/${slug.slug}`} path={`${currentPath}/${slug.slug}`}>
                      <Article id={art.id}/>
                  </Route>);
              });
          }
      });
      setRoutesOk([...res, ...localRoutes]);
  },[data,setRoutesOk,path,localRoutes, depth, pathname]);
  return root ? <div className="subroutes">
            <Switch location={{ pathname, search, state, hash:"" }}>
                {routesOk}
            </Switch>
    </div>
    :
    <div className="subroutes">
        <Switch>
            {routesOk}
        </Switch>
    </div>;
};

export default SubRoutes;
